import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import { AppBar, Box, Link, Toolbar, Typography } from '@mui/material';

import logo from '../../../assets/images/logo_new.png';

import {
  headerSx,
  toolbarSx,
  logoSx,
  headerRightSx,
  signInLinkSx,
  accentLineSx
} from '../../Common/components/Styles/AuthStyles';

const RegisterHeader = ({ showSignIn }) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: theme => theme.zIndex.appBar
      }}>
      <AppBar position="static" sx={headerSx}>
        <Toolbar disableGutters sx={toolbarSx}>
          <RouterLink to="/">
            <Box component="img" src={logo} alt="EHRZip" sx={logoSx} />
          </RouterLink>

          {showSignIn && (
            <Box sx={headerRightSx}>
              <Typography>Already registered?</Typography>

              <Link component={RouterLink} to="/sign-in" sx={signInLinkSx}>
                Sign In
              </Link>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Box sx={accentLineSx} />
    </Box>
  );
};

RegisterHeader.propTypes = {
  showSignIn: PropTypes.bool.isRequired
};

export default RegisterHeader;
